module.exports = __webpack_public_path__ + "images/bimota60a5664c076d8b559c9d241559fd6630.png";